// Куда поставить карточку-подсказку относительно подсвеченного элемента.
//
// Чистая функция без DOM: на вход — прямоугольник элемента, размер карточки и
// размер окна, на выходе — координаты. Так её видно в тесте и не нужно
// подбирать отступы вживую.

const GAP = 12; // зазор между элементом и карточкой
const EDGE = 12; // минимальный отступ от края экрана

const place = (placement, target, card) => {
  switch (placement) {
    case 'top':
      return { top: target.top - card.height - GAP, left: target.left + target.width / 2 - card.width / 2 };
    case 'left':
      return { top: target.top + target.height / 2 - card.height / 2, left: target.left - card.width - GAP };
    case 'right':
      return { top: target.top + target.height / 2 - card.height / 2, left: target.right + GAP };
    case 'bottom':
    default:
      return { top: target.bottom + GAP, left: target.left + target.width / 2 - card.width / 2 };
  }
};

const fits = (pos, card, viewport) =>
  pos.top >= EDGE &&
  pos.left >= EDGE &&
  pos.top + card.height <= viewport.height - EDGE &&
  pos.left + card.width <= viewport.width - EDGE;

const clamp = (pos, card, viewport) => ({
  top: Math.min(Math.max(pos.top, EDGE), Math.max(EDGE, viewport.height - card.height - EDGE)),
  left: Math.min(Math.max(pos.left, EDGE), Math.max(EDGE, viewport.width - card.width - EDGE)),
});

// Сначала пробуем сторону из описания шага, затем остальные по кругу. Если не
// влезает никуда (узкий экран), прижимаем к краю — лучше так, чем за экраном.
export const computeCardPosition = (target, card, viewport, placement = 'bottom') => {
  const order = [placement, 'bottom', 'top', 'right', 'left'];

  for (let i = 0; i < order.length; i += 1) {
    const pos = place(order[i], target, card);
    if (fits(pos, card, viewport)) return pos;
  }

  return clamp(place(placement, target, card), card, viewport);
};

export default computeCardPosition;
